import logo from "../assets/logos/logo.png";

function Maintenance() {
  return (
    <main
      style={{
        minHeight: "100dvh",
        background: "#F6F7F9",
        color: "#111827",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px 20px",
        boxSizing: "border-box",
      }}
    >
      <section
        style={{
          width: "100%",
          maxWidth: 420,
          textAlign: "center",
        }}
      >
        <img
          src={logo}
          alt="Urba Mart"
          style={{
            width: 96,
            height: 96,
            objectFit: "contain",
            marginBottom: 24,
          }}
        />
        <p
          style={{
            margin: "0 0 10px",
            color: "#D97706",
            fontSize: 12,
            fontWeight: 800,
            letterSpacing: 0,
            textTransform: "uppercase",
          }}
        >
          Maintenance in progress
        </p>
        <h1
          style={{
            margin: "0 0 12px",
            fontSize: 28,
            lineHeight: 1.15,
            fontWeight: 900,
          }}
        >
          Urba Mart will be back shortly
        </h1>
        <p
          style={{
            margin: "0 auto",
            maxWidth: 340,
            color: "#4B5563",
            fontSize: 15,
            lineHeight: 1.6,
          }}
        >
          We are updating the app right now. Please check again in a few
          minutes.
        </p>
        <div
          aria-hidden="true"
          style={{
            width: 56,
            height: 4,
            borderRadius: 999,
            background: "#D97706",
            margin: "28px auto 0",
          }}
        />
      </section>
    </main>
  );
}

export default Maintenance;
